import React from "react";
import { WhatsAppShareConfirmModal } from "./whatsappShareModalShared";

interface QuotationShareModalProps {
  quotation: any;
  onClose: () => void;
  onShareOfficial: () => Promise<void>;
  loading?: boolean;
}

const QuotationShareModal: React.FC<QuotationShareModalProps> = ({
  quotation,
  onClose,
  onShareOfficial,
  loading = false,
}) => {
  return (
    <WhatsAppShareConfirmModal
      title="Share Quotation"
      customerName={quotation?.customer_name || quotation?.customer?.name || ""}
      customerPhone={quotation?.customer_phone || quotation?.customer?.phone || ""}
      documentNumber={quotation?.quotation_no || ""}
      grandTotal={quotation?.grand_total || quotation?.total_amount || 0}
      pdfFileName={`Quotation_${quotation?.quotation_no || "detail"}.pdf`}
      onClose={onClose}
      onConfirm={onShareOfficial}
      loading={loading}
    />
  );
};

export default QuotationShareModal;
